import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { PromoSection } from "@core/types";
import { useConfig } from "../../providers/config";
import { Image } from "../Image/Image";
import { usePromoSection } from "../../hooks/usePromoSection";

type SliderProps = PromoSection;

const Slider = ({ ...promoSectionProps }: SliderProps) => {
  const config = useConfig();
  const { promos, handlePromoClick, isLoading } = usePromoSection(promoSectionProps);

  const autoplayDelayMs = Number(config.homeSliderAutoplaySeconds) * 1000;
  const totalItems = promos?.length || 0;

  if (!totalItems) return null;

  return (
    <div className="h-full">
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={12}
        slidesPerView={1}
        loop
        centeredSlides={false}
        pagination={{
          clickable: true,
          dynamicBullets: false,
        }}
        autoplay={{
          delay: autoplayDelayMs,
          disableOnInteraction: false,
        }}
        simulateTouch
        touchReleaseOnEdges
        className="!overflow-hidden "
      >
        {promos?.map((promo) => {
          const firstImage = promo?.images![0];
          return (
            <SwiperSlide key={promo.id}>
              <div
                onClick={() => handlePromoClick(promo)}
                className="relative overflow-hidden rounded-[1.125rem] min-h-[11rem] cursor-pointer w-full h-full"
              >
                <Image
                  alt={promo.title}
                  src={firstImage?.src}
                  placeholder={firstImage?.base64}
                  lazyLoad={false}
                  className="w-full h-[11rem] sm:h-[14rem] md:h-[14.6875rem] lg:h-full max-h-[293px] object-cover"
                />
                <div className="absolute top-0 left-0 right-0 z-10 w-full h-[70px] pointer-events-none bg-gradient-to-b from-black/65 to-transparent" />
                <span className="m-1 absolute top-1 left-2 text-[16px] z-20 font-bold text-white [text-shadow:_0px_0px_0px_rgba(0,0,0,0.8),_0_0_1px_rgba(0,0,0,1)]">
                  {promo.title}
                </span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Slider;
